(() => {
  const experiments = window.VRExperiments;
  if (!experiments?.assignment || !experiments?.config) return;

  const { config, assignment } = experiments;
  const propertyValue = `${assignment.experimentId}:${assignment.variant}`;
  const eventBase = {
    experiment_id: assignment.experimentId,
    experiment_name: config.name,
    experiment_variant: assignment.variant,
    experiment_mode: config.mode,
    qa: assignment.qa,
    product_id: String(config.productId || ''),
    product_handle: config.productHandle || '',
    page_path: location.pathname
  };

  const publishShopifyEvent = (name, payload, attempt = 0) => {
    const shopifyPublish = window.Shopify?.analytics?.publish;
    if (typeof shopifyPublish === 'function') {
      try {
        const result = shopifyPublish(name, payload);
        if (result && typeof result.catch === 'function') {
          result.catch((error) => console.warn('[VitaRenew Experiments] Shopify event failed.', error));
        }
        return true;
      } catch (error) {
        console.warn('[VitaRenew Experiments] Shopify event failed.', error);
        return false;
      }
    }

    if (attempt < 20) {
      window.setTimeout(() => publishShopifyEvent(name, payload, attempt + 1), 250);
    }
    return false;
  };

  const publish = (eventName, detail = {}) => {
    if (!config.trackingEnabled || assignment.qa) return false;
    const payload = { ...eventBase, ...detail };
    const published = publishShopifyEvent(`vitarenew:experiment_${eventName}`, payload);
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: `vitarenew_experiment_${eventName}`, ...payload });
    } catch (error) {}
    document.dispatchEvent(new CustomEvent(`vitarenew:experiment:${eventName}`, { detail: payload }));
    return published;
  };

  const cartProperties = () => experiments.cartProperties?.() || {};
  const mergeProperties = (properties = {}) => ({ ...properties, ...cartProperties() });

  const syncForm = (form) => {
    if (!(form instanceof HTMLFormElement) || assignment.qa) return;
    let input = form.querySelector('input[data-vr-experiment-property]');
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'properties[_vr_experiment]';
      input.dataset.vrExperimentProperty = 'true';
      form.appendChild(input);
    }
    input.value = propertyValue;
  };

  const syncForms = (scope = document) => {
    scope.querySelectorAll('form[action*="/cart/add"]').forEach(syncForm);
  };

  const syncCartAttribute = async () => {
    if (assignment.qa) return;
    const sessionKey = `vr_cart_assignment_synced:${propertyValue}`;
    try {
      if (sessionStorage.getItem(sessionKey) === '1') return;
    } catch (error) {}
    try {
      const response = await fetch(window.routes?.cart_update_url || '/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ attributes: { vr_experiment__: propertyValue } })
      });
      if (!response.ok) throw new Error(`Cart attribute failed (${response.status}).`);
      try { sessionStorage.setItem(sessionKey, '1'); } catch (error) {}
    } catch (error) {
      console.warn('[VitaRenew Experiments] Cart assignment could not be synchronized.', error);
    }
  };

  experiments.publish = publish;
  experiments.track = publish;
  experiments.mergeProperties = mergeProperties;

  const init = () => {
    syncForms();
    new MutationObserver((mutations) => {
      mutations.forEach((mutation) => mutation.addedNodes.forEach((node) => {
        if (!(node instanceof Element)) return;
        if (node.matches?.('form[action*="/cart/add"]')) syncForm(node);
        syncForms(node);
      }));
    }).observe(document.body, { childList: true, subtree: true });

    const exposureKey = `vr_exposure:${propertyValue}`;
    let alreadySent = false;
    try { alreadySent = sessionStorage.getItem(exposureKey) === '1'; } catch (error) {}
    if (!alreadySent) {
      window.setTimeout(() => {
        publish('exposure');
        try { sessionStorage.setItem(exposureKey, '1'); } catch (error) {}
      }, 750);
    }
    syncCartAttribute();
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
